import { ILanguage } from "src/constants/locale";

export const getLocale = (language: ILanguage) => (language === "de" ? "de-DE" : "en-US");
